const List = () => import(/* webpackChunkName: "HuntingTicketAnnulmentOrders" */ 'RootDir/modules/HuntingTickets/HuntingTicketAnnulmentOrder/List.vue');
const Create = () => import(/* webpackChunkName: "HuntingTicketAnnulmentOrders" */ 'RootDir/modules/HuntingTickets/HuntingTicketAnnulmentOrder/Create.vue');
const ShowWrapper = () => import(/* webpackChunkName: "HuntingTicketAnnulmentOrders" */ 'RootDir/modules/HuntingTickets/HuntingTicketAnnulmentOrder/ShowWrapper.vue');

export default [
  {
    path: 'list',
    name: 'hunting-ticket-annulment-orders',
    component: List,
  },
  {
    path: 'create',
    name: 'create-hunting-ticket-annulment-order',
    component: Create,
  },
  {
    path: 'show/:orderId',
    name: 'show-hunting-ticket-annulment-order',
    props: true,
    component: ShowWrapper,
  },
];
